import { render, staticRenderFns } from "./ysPlayer.vue?vue&type=template&id=49fc52db&scoped=true&"
import script from "./ysPlayer.vue?vue&type=script&lang=js&"
export * from "./ysPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ysPlayer.vue?vue&type=style&index=0&id=49fc52db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fc52db",
  null
  
)

export default component.exports